import { ORPCError } from '@orpc/client';
import type { QueryClient } from '@tanstack/react-query';

import { orpc } from './orpc.ts';

/** Текущий пользователь: профиль, роли, разрешения — для меню, ⌘K и проверок на экранах. */
export const meQuery = orpc.identity.me.queryOptions({ staleTime: 60_000, retry: false });

export function isUnauthorized(error: unknown): boolean {
  return error instanceof ORPCError && error.status === 401;
}

/** Студия включила обязательную 2FA, а у пользователя её нет: сервер закрыл всё, кроме профиля. */
export function isTwoFactorRequired(error: unknown): boolean {
  return error instanceof ORPCError && error.code === 'identity.two_factor_required';
}

/** Куда вернуться после входа: только адреса этого приложения. */
export function safeRedirect(target: string | undefined): string {
  if (!target?.startsWith('/') || target.startsWith('//')) return '/';
  return target;
}

/** После входа или выхода всё, что было в кэше, принадлежало другому сеансу. */
export async function resetSession(queryClient: QueryClient): Promise<void> {
  await queryClient.cancelQueries();
  queryClient.clear();
}
